import { RootState } from "../reducers/store"
import { isInitSyncDone } from "../reducers/roomSyncStatusSelectors"

const INTERVAL = 60 * 30
const ROOMS_PER_REPORT = 5
const MAX_MESSAGES = 30

let worker: number | null = null
const reportedRooms = new Set<string>()

export const getCompletenessPayload = (state: RootState) => {
  const chats = state.chats.filter((c) => c.room)
  if (chats.length === 0) return null

  // Rooms not yet reported in this cycle
  let freshChats = chats.filter((c) => !reportedRooms.has(c.jid))

  // No fresh rooms left — rotate: reset and start the cycle over
  if (freshChats.length === 0) {
    reportedRooms.clear()
    freshChats = [...chats]
  }

  // Pick min(ROOMS_PER_REPORT, available) rooms at random from the fresh pool
  const selected: typeof chats = []
  const pool = [...freshChats]
  while (selected.length < ROOMS_PER_REPORT && pool.length > 0) {
    const idx = Math.floor(Math.random() * pool.length)
    selected.push(...pool.splice(idx, 1))
  }

  // Mark selected rooms as reported for this cycle
  selected.forEach((c) => reportedRooms.add(c.jid))

  const rooms = selected.map((chat) => {
    const messages = state.messages[chat.jid]?.messages?.slice(-MAX_MESSAGES)
    return {
      jid: chat.jid,
      ids: messages?.map((m) => m.id),
    }
  })

  return { rooms }
}

const report = () => {
  if (window.XMPP?.status != "online") {
    console.debug("Completeness skipped because of disconnected XMPP")
    return
  }

  if (!isInitSyncDone(window.store.getState())) {
    console.debug("Completeness skipped because of sync in progress")
    return
  }

  console.debug(`Completeness run: ${worker}`)

  const payload = getCompletenessPayload(window.store.getState())
  if (payload) {
    window.analytics.track("CompletenessRoomsReport", payload)
  }
  console.debug("CompletenessRoomsReport", payload)
}

export const runReporting = () => {
  worker = window.setInterval(report, 1000 * INTERVAL)
  report()
}
